import { Link } from "react-router-dom";
import { money } from "@/lib/api";
import { Img, RuneMark } from "./Img";

const STOCK = {
  in_stock: ["In stock", "text-emerald-400"],
  low_stock: ["Low stock", "text-amber-400"],
  out_of_stock: ["Out of stock", "text-red-400"],
  on_order: ["Made to order", "text-amber-300"],
  enquire: ["Enquire", "text-slate-300"],
};

export function StockBadge({ status, testId }) {
  const [label, cls] = STOCK[status] || STOCK.in_stock;
  return (
    <span className={`inline-flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-[0.16em] ${cls}`} data-testid={testId}>
      <span className="h-1.5 w-1.5 rotate-45 bg-current" />{label}
    </span>
  );
}

export function ProductCard({ p }) {
  const img = p.images?.[0];
  const onSale = p.compare_at_price && p.compare_at_price > p.price;
  return (
    <Link to={`/product-page/${p.slug}`} data-testid={`product-card-${p.slug}`}
      className="group relative flex flex-col overflow-hidden border border-[color:var(--line)] bg-[color:var(--bg-2)] transition-colors duration-300 hover:border-[color:var(--ice)]/50">
      <div className="relative aspect-[4/3] overflow-hidden bg-[#0f1216]">
        {img ? (
          <Img src={img.url} alt={img.alt || p.name} sizes="(max-width:640px) 100vw, (max-width:1024px) 50vw, 25vw"
            className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.04]" />
        ) : (
          <div className="knot-bg flex h-full w-full flex-col items-center justify-center gap-3 opacity-90">
            <RuneMark className="h-10 w-10 text-[color:var(--line-2)]" />
            <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-slate-500">{p.brand || "Jorvik Tuning"}</span>
          </div>
        )}
        {onSale && <span className="absolute left-3 top-3 bg-[color:var(--bronze)] px-2 py-1 font-mono text-[10px] font-bold uppercase tracking-wider text-black">Offer</span>}
      </div>
      <div className="flex flex-1 flex-col gap-3 p-5">
        {p.brand && <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-slate-500">{p.brand}</span>}
        <h3 className="font-display text-xl font-semibold uppercase leading-tight text-slate-100 transition-colors group-hover:text-white">{p.name}</h3>
        <div className="mt-auto flex items-end justify-between pt-2">
          <div className="font-mono">
            {onSale && <span className="mr-2 text-xs text-slate-500 line-through">{money(p.compare_at_price)}</span>}
            <span className="text-lg text-[color:var(--ice)]" data-testid={`product-card-price-${p.slug}`}>{money(p.price)}</span>
          </div>
          <StockBadge status={p.stock_status} />
        </div>
      </div>
      <span className="absolute bottom-0 left-0 h-[2px] w-0 bg-[color:var(--ice)] transition-all duration-500 group-hover:w-full" />
    </Link>
  );
}
